// extracted by mini-css-extract-plugin
export default {"root":"Title__root--3BenN","title":"Title__title--1mO0W","description":"Title__description--vXE4P","root_mobile":"Title__root_mobile--1eDQG"};